import React from 'react';
import PropTypes from "prop-types";

import {styled} from "@mui/material/styles";

import {ReactComponent as Cross} from "assets/img/cross.svg";
import {greyishBlue300} from "assets/jss/main";

AddIcon.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    size: PropTypes.number,
};

const StyledSvg = styled(Cross)(({ theme, color, disabled, size}) => ({
    ...size && {
        width: size,
        height: size
    },
    'path': {
        ...color !== null && {
            stroke: color
        },
        ...disabled === true &&  {
            stroke: greyishBlue300
        }
    },
}));

export default function AddIcon(props) {
    return <StyledSvg {...props} />;
}
